import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import ReactDOM from 'react-dom';
import ModalFooter from '../ModalFooter';
import Button from '../Button';
import PubSub from '../tools/PubSub';
var MODAL_ADD = 'MODAL_ADD';
var MODAL_DEL = 'MODAL_DEL';
export default function staticModal(ModalComponent) {
  var pubSub = new PubSub();
  var uid = Date.now();
  var modalContainer;
  /**
   * 模态框参数
   * @typedef ModalOptions
   * @property {number} [id]
   * @property {'help' | 'warning' | 'delete' | 'success' | 'question'} type
   * @property {any} title
   * @property {any} content
   * @property {any} okText
   * @property {any} cancelText
   * @property {number} zIndex
   * @property {Function} onOk
   * @property {Function} onCancel
   */

  /**
   * 创建静态 modal 的容器元素
   * @param {Function} callback
   */

  function createModalContainer(callback) {
    modalContainer = document.createElement('div');
    modalContainer.classList.add('jmtd-static-modal-container');
    document.body.appendChild(modalContainer);
    ReactDOM.render( /*#__PURE__*/React.createElement(StaticModalWrap, null), modalContainer, function () {
      return callback();
    });
  }
  /**
   * 打开一个弹窗
   * @param {ModalOptions} options
   * @returns {any} id
   */


  function open(options) {
    options = _objectSpread(_objectSpread({}, options), {}, {
      id: uid++
    });

    if (!modalContainer) {
      createModalContainer(function () {
        pubSub.publish(MODAL_ADD, options);
      });
    } else {
      pubSub.publish(MODAL_ADD, options);
    }

    return options.id;
  }
  /**
   * 关闭一个弹窗
   * @param {Number} id
   */


  function close(id) {
    pubSub.publish(MODAL_DEL, id);
  }

  var StaticModalWrap = /*#__PURE__*/function (_React$PureComponent) {
    _inherits(StaticModalWrap, _React$PureComponent);

    var _super = _createSuper(StaticModalWrap);

    function StaticModalWrap(props) {
      var _this;

      _classCallCheck(this, StaticModalWrap);

      _this = _super.call(this, props);

      _defineProperty(_assertThisInitialized(_this), "addModal", function (options) {
        _this.setState(function (state) {
          return {
            modals: state.modals.concat(options)
          };
        });
      });

      _defineProperty(_assertThisInitialized(_this), "delModal", function (id) {
        _this.setState(function (state) {
          return {
            modals: state.modals.filter(function (modal) {
              return modal.id !== id;
            })
          };
        });
      });

      _defineProperty(_assertThisInitialized(_this), "operateBtn", function (_ref) {
        var id = _ref.id,
            okText = _ref.okText,
            cancelText = _ref.cancelText,
            onOk = _ref.onOk,
            onCancel = _ref.onCancel,
            size = _ref.size;
        if (!okText && !cancelText) return null;
        return /*#__PURE__*/React.createElement(ModalFooter, {
          pos: "right",
          noBorder: true
        }, cancelText && /*#__PURE__*/React.createElement(Button, {
          size: size || 'small',
          onClick: function onClick() {
            _this.delModal(id);

            onCancel && onCancel();
          }
        }, cancelText), okText && /*#__PURE__*/React.createElement(Button, {
          semantic: "primary",
          size: size || 'small',
          onClick: function onClick() {
            _this.delModal(id);

            onOk && onOk();
          }
        }, okText));
      });

      _this.state = {
        modals: []
      };
      return _this;
    }

    _createClass(StaticModalWrap, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        pubSub.subscribe(MODAL_ADD, this.addModal);
        pubSub.subscribe(MODAL_DEL, this.delModal);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        pubSub.unsubscribe(MODAL_ADD, this.addModal);
        pubSub.unsubscribe(MODAL_DEL, this.delModal);
      }
      /**
       * 添加一个模态框
       * @param {ModalOptions} options -
       */

    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var modals = this.state.modals;
        return /*#__PURE__*/React.createElement(React.Fragment, null, modals.map(function (modal) {
          var id = modal.id,
              type = modal.type,
              title = modal.title,
              content = modal.content,
              explainText = modal.explainText,
              followUpText = modal.followUpText,
              icon = modal.icon,
              iconSize = modal.iconSize,
              width = modal.width,
              iconColor = modal.iconColor,
              portalZIndex = modal.portalZIndex;
          return /*#__PURE__*/React.createElement(ModalComponent, {
            key: id,
            visible: true,
            type: type,
            explainText: title || explainText,
            followUpText: content || followUpText,
            icon: icon,
            iconSize: iconSize,
            width: width,
            iconColor: iconColor,
            portalZIndex: portalZIndex !== null && portalZIndex !== void 0 ? portalZIndex : document.querySelector('.jmtd-portal-adjust') ? 100000 : undefined,
            operateBtn: _this2.operateBtn(modal)
          });
        }));
      }
    }]);

    return StaticModalWrap;
  }(React.PureComponent);

  return {
    open: open,
    close: close
  };
}